import {useEffect, useState} from 'react';
import {Alert, Snackbar, Typography} from '@mui/material';
import {getApiErrorKind, getApiErrorMessage, getApiTraceId} from '../../common/apiErrors';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import ReportProblemButton from '../feedback/ReportProblemButton';

type Props = {
    error: unknown;
    retryAction?: React.ReactNode;
};

export const ApiErrorFeedback = ({error, retryAction}: Props) => {
    const {t} = useAppTranslation();
    const [toastOpen, setToastOpen] = useState(false);
    const kind = error ? getApiErrorKind(error) : undefined;
    const message = error ? getApiErrorMessage(error, t) : '';
    const traceId = error ? getApiTraceId(error) : '';

    useEffect(() => setToastOpen(Boolean(error && kind === 'server')), [error, kind]);

    if (!error) return null;
    if (kind !== 'server') return <Alert severity="error" action={retryAction}>{message}</Alert>;

    return (
        <Snackbar open={toastOpen} autoHideDuration={6000} onClose={() => setToastOpen(false)} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
            <Alert severity="error" onClose={() => setToastOpen(false)}>
                {message}
                {traceId && <Typography variant="caption" display="block">Trace ID: {traceId}</Typography>}
                <ReportProblemButton error={error} traceId={traceId}/>
            </Alert>
        </Snackbar>
    );
};
